const ProductValidation = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Name is required";
  }
  if (!values.status) {
    // You can return translation keys
    errors.status = "Status is required";
  }
  if (!values.retail_price) {
    // You can return translation keys
    errors.retail_price = "Price is required";
  }

  if (!values.skip_stock) {
    // You can return translation keys
    errors.skip_stock = "This is required";
  }

  if (!values.category_id) {
    // You can return translation keys
    errors.category_id = "Category is required";
  }

  if (!values.code) {
    errors.code = "Code is required";
  }

  return errors;
};

export default ProductValidation;
